import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-255c2d2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brush-map__aside" }
const _hoisted_2 = { class: "brush-map__buttons brush-map__display" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 5. Сохранить ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 5. Изменить ")
const _hoisted_5 = { class: "brush-map__current-color" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Текущий цвет:", -1))

import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import BrushMapSelectColor from './components/BrushSelectColor/BrushMapSelectColor.vue'
import BrushMapSelectTooth from './components/BrushMapSelectTooth.vue'
import BrushMapSelectFirm from './components/BrushMapSelectFirm.vue'
import BrushMapSelected from '@/pages/BrushMapPage/components/BrushMapSelected.vue'
import { useOrganizationModules } from '@/shared/composables'


export default /*#__PURE__*/_defineComponent({
  props: {
  currentName: String,
  currentColor: String,
  brushesFirm: Object,
  firstGroup: String,
  secondGroup: String,
  firstGroupColors: Array,
  secondGroupColors: Array,
},
  emits: [
  'sendReport',
  'updateReport',
  'resetColors',
  'changeFirm',
  'changeColor',
  'deleteColor',
],
  setup(__props, { emit }) {





const { organizationModules } = useOrganizationModules()
const route = useRoute()
const isPreviewMode = computed(() => route.query['view-mode'] === '1')
const isCreationPage = computed(() => route.params.reportId === '0')
const patientId = computed(() => route.params.patientId)
const isModalVisible = ref(false)

const sendReport = () => {
  emit('sendReport')
  isModalVisible.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BrushMapSelectTooth),
      _createVNode(BrushMapSelectFirm, {
        brushesFirm: __props.brushesFirm,
        onChangeFirm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeFirm', $event))),
        onResetColors: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('resetColors')))
      }, null, 8, ["brushesFirm"]),
      _createVNode(BrushMapSelectColor, {
        brushesFirm: __props.brushesFirm,
        currentColor: __props.currentColor,
        currentName: __props.currentName,
        onChangeColor: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('changeColor', $event)))
      }, null, 8, ["brushesFirm", "currentColor", "currentName"]),
      _createVNode(BrushMapSelected, {
        "first-group": __props.firstGroup,
        "first-group-colors": __props.firstGroupColors,
        "second-group": __props.secondGroup,
        "second-group-colors": __props.secondGroupColors,
        class: "brush-map__display",
        onDeleteColor: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('deleteColor', $event)))
      }, null, 8, ["first-group", "first-group-colors", "second-group", "second-group-colors"]),
      _createElementVNode("div", _hoisted_2, [
        (_unref(isCreationPage) && !_unref(isPreviewMode))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              disabled: _unref(organizationModules).indexOf('brushmap') <= -1,
              class: "brush-map__button",
              round: "",
              size: "large",
              type: "primary",
              onClick: sendReport
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["disabled"]))
          : (!_unref(isCreationPage) && !_unref(isPreviewMode))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                disabled: _unref(organizationModules).indexOf('brushmap') <= -1,
                class: "brush-map__button",
                round: "",
                size: "large",
                type: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('updateReport')))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", {
        style: _normalizeStyle({ background: __props.currentColor })
      }, null, 4),
      _createElementVNode("p", null, _toDisplayString(__props.currentName), 1)
    ])
  ], 64))
}
}

})